{
  "version": 1,
  "asset_id": "5e15a503-1701-439d-b825-34d65f360649",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5e15a503-1701-439d-b825-34d65f360649/mark-384.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5e15a503-1701-439d-b825-34d65f360649/mark-384.webp",
  "original_filename": "mark-384.webp",
  "size": 28080,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:34Z"
}
